module.exports = __webpack_public_path__ + "static/media/linkedin-logo-white.4e031ef5.png";